import { get } from 'lodash';

export const getTopology = state => state.topology;
export const getIsBlogPublished = state => Boolean(get(state, 'topology.baseUrl'));
